<template>
    <div id="app">
        <NavigationPane />
        
        <div class="w3-main" style="margin-left:300px">
            <header>
                <router-link to="/">
                    <img src="/guineafowl.jpeg" style="width:65px;" class="w3-circle w3-right w3-margin w3-hide-large w3-hover-opacity">
                </router-link>
                <span class="w3-button w3-hide-large w3-xxlarge w3-hover-text-grey" @click="navOpen()"><i class="fa fa-bars"></i></span>
                <div class="w3-container">
                    <h1><b>Birding Life List</b></h1>
                </div>
            </header>

            <router-view />
        </div>
    </div>
</template>

<script setup>
import NavigationPane from "./components/NavigationPane"
// I really don't like how these are split out
function navOpen() {
    document.getElementById("nav-sidebar").style.display = "block";
    document.getElementById("nav-overlay").style.display = "block";
}
</script>

<script>
export default {
  name: 'App',
}
</script>

<style>
</style>
